module.exports = __webpack_public_path__ + "static/media/hero-banner.07a3f3ca.jpg";